import { render, staticRenderFns } from "./DocumentColumns.vue?vue&type=template&id=3ef5a55c"
import script from "./DocumentColumns.vue?vue&type=script&lang=ts"
export * from "./DocumentColumns.vue?vue&type=script&lang=ts"
import style0 from "./DocumentColumns.vue?vue&type=style&index=0&id=3ef5a55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports